module.exports = __webpack_public_path__ + "static/image/font/pc/bmyeonsung-2@3x.jpg?1bc31483";